import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { PagespinnerService } from './services/pagespinner.service';

@Injectable()
export class LoaderHttpInterceptor implements HttpInterceptor {

    constructor(private pagespinnerService: PagespinnerService) {}

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.pagespinnerService.show();

        return next.handle(req).pipe(tap(() => {
            this.pagespinnerService.hide();
        }));
    }
}
